<template>
    <div>
        <!-- <img class="logo_img" src="../assets/logo.png" /> -->
        <div class="content">
            <img class="content_img" :src="imgUrl" />
            <span class="content_tip">{{ this.textMsg[this.language.key][projectionStatus] + (projectionStatus === 'textSharing' ? this.roomName : '') }}</span>
            <!-- 输入投屏码 -->
            <div v-if="status === 'input' || status === 'connecting'"  class="content_div">
                <input v-model="castCode" class="content_div_input" maxlength="6" />
                <img v-if="status === 'connecting'" class="content_div_img" src="../assets/loading.png" />
            </div>
            <!-- 输入校验码 -->
            <div v-else-if="status === 'authorize' || status === 'authorizing'"  class="content_div">
                <input v-model="verificationCode" class="content_div_input" maxlength="4" />
                <img v-if="status === 'authorizing'" class="content_div_img" src="../assets/loading.png" />
            </div>
            <!-- 结束、暂停、恢复按钮 -->
            <div v-else style="margin: 16px;">
                <el-row>
                    <el-button type="primary" size="medium" @click="handlePause" v-if="status === 'running'">{{ textMsg[language.key].textPause }}</el-button>
                    <el-button type="primary" size="medium" @click="handleResume" v-else-if="status === 'paused'">{{ textMsg[language.key].pauseResumeLabel }}</el-button>
                    <el-button type="danger" size="medium" @click="handleStop" v-if="status === 'running' || status === 'paused'">{{ textMsg[language.key].recordStopLabel }}</el-button>
                    <el-button type="danger" size="medium" @click="handleStop" v-if="status === 'error'">{{ textMsg[language.key].confirm }}</el-button>
                </el-row>
            </div>
            <span v-if="errorTipKey" class="content_error">{{ this.textMsg[this.language.key][errorTipKey] }}</span>
            <!-- 设置弹窗 -->
            <el-popover
                placement="top-end"
                trigger="click"
                :visible-arrow="false"
                @hide="handleSettingHide"
                width="300"
                height="94">
                <div>
                    <div class="setting_item">
                        <span class="setting_label">{{ this.textMsg[this.language.key].deviceName }}</span>
                        <input v-model="displayName" :disabled="status !== 'input'" class="setting_item_input" maxlength="20" />
                    </div>
                    <div class="setting_item">
                        <span class="setting_label">{{ this.textMsg[this.language.key].language }}</span>
                        <el-select v-model="language" value-key="name">
                            <el-option
                                v-for="item in languageList"
                                :key="item.key"
                                :label="item.name"
                                :value="item">
                                <div class="setting_lang_item" :style="{backgroundColor: language.key === item.key ? '#5E87FF' : 'transparent'}" >
                                    <div :style="{color: language.key === item.key ? '#FFFFFF' : '#000000'}">{{ item.name }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="setting_icon" slot="reference" @click="showSetting = !showSetting" :style="{backgroundColor: showSetting ? '#5E87FF' : 'transparent'}">
                    <img :src="settingImgUrl" class="setting_icon_img" />
                </div>
            </el-popover>
            <div class="content_footer">
                <el-link type="primary" @click="toDownloadPage">{{ textMsg[language.key].toDownloadLabel }}</el-link>
                <!-- <span class="content_footer_text">Copyright © 2024 Lango All Rights Reserved</span> -->
            </div>
        </div>

    </div>
</template>

<script>
    import home from "../i18n/home";
    import Janus from "../utils/janus-audio";

    const errorIcon = require("@/assets/error.png");
    const castingIcon = require("@/assets/casting.png");
    const connectedIcon = require("@/assets/connected.png");
    const settingIcon = require("@/assets/setting.png");
    const settingSelectedIcon = require("@/assets/setting_selected.png");

    const address = process.env.NODE_ENV === "development" ? "share.hellogo.tech" : location.host;
    const serverUrl = "wss://" + address + "/ws";

    let janus, timeout, interval, keyFrameCount, errorCount, publisherId;
    let opaqueId = "WebCast-" + Janus.randomString(12);
    let videoRoomHandle = {}, videoMid = 0, audioMid = 1;

    export default {
        name: "Home",
        computed: {
            imgUrl() {
                let icon;
                if (this.status === 'running' || this.status === 'paused') {
                    icon = castingIcon;
                } else if (this.errorTipKey || this.status === 'error') {
                    icon = errorIcon;
                } else {
                    icon = connectedIcon;
                }
                return icon;
            },
            settingImgUrl() {
                return this.showSetting ? settingSelectedIcon : settingIcon;
            }
        },
        watch: {
            castCode(newVal, oldVal) {
                if (newVal) {
                    this.castCode = newVal.toUpperCase();
                    if (newVal.length === 6) {
                        this.handleConnect();
                    }
                }
            },
            verificationCode(newVal, oldVal) {
                if (newVal && newVal.length === 4) {
                    this.checkVerificationCode();
                }
            }
        },
        data() {
            return {
                textMsg: home, //国际化
                projectionStatus: "", //投屏状态文字
                errorTipKey: "",
                language: { name: "English", key: "en" }, //当前语言
				shareServerName: "", //大屏名称
                status: "input", //投屏状态标识 input-输入投屏码, connecting-连接中, connected-已连接, authorize-输入验证码, authorizing-验证中, paused-投屏暂停, running-投屏中, error-已经被踢出或超时等, close-断开连接
                castCode: "", // 输入的投屏码
                verificationCode: "", // 输入的4位验证码
                displayName: 'WebCast',
                roomName: '', // 大屏的名称
                showSetting: false, // 是否正在显示设置弹窗
                showLanguage: false, // 是否正在显示选择语言的弹窗
                languageList: [
                    // { name: "中文简体", key: "zh" },
                    // { name: "中文繁體", key: "zh_rTW" },
                    { name: "English", key: "en" }
                ]
            }
        },

        mounted() {
            let name = localStorage.getItem("displayName");
            if (name) {
                console.info("displayName = " + name);
                this.displayName = name;
            }
            let lang = localStorage.getItem("language", JSON.stringify(this.language));
            if (lang) {
                console.info("language = " + lang);
                this.language = JSON.parse(lang);
            }
            //设置标题国际化
            window.document.title = this.textMsg[this.language.key].title;
            //重定向到https
            if (window.location.href.indexOf("localhost") < 0 && window.location.protocol == "http:") {
                //重定向到https
                window.location.href = window.location.href.replace("http", "https");
                return;
            }
            
            this.projectionStatus = "connectLabel";
            // 初始化Janus
            this.initJanus();
        },

        methods: {
            /**
             * 下载应用程序
             */
            toDownloadPage() {
                let targetUrl = "https://cast.hellogo.tech/v3";
                console.info("targetUrl - " + targetUrl);
                window.open(targetUrl, "_blank");
            },

            /**
             * 初始化Janus
             */
             initJanus() {
                Janus.init({debug: "all", callback: () => {
                    if (!Janus.isWebrtcSupported()) {
                        this.unsurpport();
                        return;
                    }
                }});
            },

            unsurpport() {
                this.$alert(this.textMsg[this.language.key].unsurport, this.textMsg[this.language.key].notice, { confirmButtonText: this.textMsg[this.language.key].confirm });
            },

            /**
             * 输入投屏码后，点击连接的事件处理
             * 创建janus、连接WebSocket、创建会话、加载插件、加入房间、开始投屏
             */
            handleConnect() {
                this.projectionStatus = "tipsConnecting";
                if(!Janus.isWebrtcSupported()) {
                    this.unsurpport();
                    return;
                }
                if (!this.castCode) {
                    this.errorTipKey = "inputMsg";
                    return;
                }
                if (this.status === 'connecting') {
                    return;
                }
                this.status = 'connecting';
                // 建立连接，创建会话
                janus = new Janus({
                    server: serverUrl,
                    iceServers: [{urls: "turn:47.88.28.235:3478", username: "dmsCoTurn", credential: "dms2023LangoServer"}],
                    success: () => {
                        // 加载VideoRoom插件
                        janus.attach({
                            plugin: "janus.plugin.videoroom",
							opaqueId: opaqueId,
                            success: (pluginHandle) => {
                                // 加载插件成功，加入房间
                                this.errorTipKey = "";
                                videoRoomHandle = pluginHandle;
                                this.joinRoom();
                            },
                            error: (error) => {
                                this.errorTipKey = "pluginError";
                                this.status = 'input';
                                janus.destroy();
                            },
                            consentDialog: (on) => {
                                Janus.log("consentDialog should " + on);
                            },
                            iceState: (state) => {
                                Janus.log("ICE state changed to " + state);
                            },
                            mediaState: (medium, on, mid) => {
                                Janus.log("mediaState " + (on ? "started" : "stopped") + " receiving our " + medium + " (mid=" + mid + ")");
                                if (on) {
                                    if (medium === 'audio') {
                                        audioMid = mid;
                                    } else if (medium === 'video') {
                                        videoMid = mid;
                                        this.requestKeyFrame();
                                        if (interval) {
                                            clearInterval(interval);
                                        }
                                        keyFrameCount = 0;
                                        interval = setInterval(() => {
                                            keyFrameCount = keyFrameCount + 1;
                                            if (keyFrameCount <= 6) {
                                                this.requestKeyFrame();
                                            } else {
                                                clearInterval(interval);
                                            }
                                        }, 500);
                                    }
                                }
                            },
                            webrtcState: (on) => {
                                Janus.log("webrtcState our WebRTC PeerConnection is " + (on ? "up" : "down") + " now");
                                if(!on && this.projectionStatus !== "kicked") {
                                    this.jumpToError("disconnect");
                                }
                            },
                            slowLink: (uplink, lost, mid) => {
                                Janus.warn("slowLink reports problems " + (uplink ? "sending" : "receiving") + " packets on mid " + mid + " (" + lost + " lost packets)");
                            },
                            onmessage: this.handleMessage,
                            onlocaltrack: this.handleLocalTrack,
                            onremotetrack: (track, mid, on) => {},
                            oncleanup: () => {}
                        });
                    },
                    error: (error) => {
                        this.status = "input";
                        this.projectionStatus = "connectLabel";
                        this.errorTipKey = "serverError";
                    },
                    destroyed: () => {
                        this.castCode = "";
                        this.verificationCode = "";
                    }
                });
            },

            /**
             * 加载插件之后，加入到指定房间
             * 加入成功之后，会在onmessage收到joined的消息
             */
            joinRoom() {
                let join = {
                    request: "join",
                    room: this.castCode,
                    ptype: "publisher",
                    display: this.displayName
                };
                videoRoomHandle.send({ message: join });
            },                                                                

            /**
             * 加入房间之后，请求授权，等待对方同意后才能投屏
             */
            authorize() {
                if(!Janus.isWebrtcSupported()) {
                    this.status = 'input';
                    this.unsurpport();
                    return;
                }
                errorCount = 0;
                this.status = 'authorize';
                this.projectionStatus = "textInputVerificationCode";
                this.errorTipKey = "";
                let authorize = {
                    request: "authorize",
                    display: this.displayName,
                    id: publisherId
                };
                videoRoomHandle.send({ message: authorize });
                if (timeout) {
                    clearTimeout(timeout);
                }
                timeout = setTimeout(() => {
                    // 两分钟超时
                    this.jumpToError("timeout");
                }, 2 * 60 * 1000);
            },

            /**
             * 校验验证码是否正确
             */
            checkVerificationCode() {
                if (!this.verificationCode) {
                    this.errorTipKey = "inputMsg";
                    return;
                }
                if (this.status === 'authorizing') {
                    return;
                }
                this.status = 'authorizing';
                this.projectionStatus = "textAuthorize";
                let authorize = {
                    request: "authorizeCode",
                    code: this.verificationCode,
                    id: publisherId
                };
                videoRoomHandle.send({ message: authorize });
            },

            /**
             * 开始投屏
             */
            startProjection() {
                this.errorTipKey = "";
                // publish our stream
                if(Janus.webRTCAdapter.browserDetails.browser === "safari") {
                    // Safari expects a user gesture to share the screen: see issue #2455
                    this.$alert("Do you allow this webpage to be projected", "Tip", { confirmButtonText: 'Yes', callback: action => {
                        this.creatOffer();
                    }});
                } else {
                    // Other browsers should be fine, we try to call getDisplayMedia directly
                    this.creatOffer();
                }
            },

            /**
             * 请求主帧
             */
            requestKeyFrame() {
                let configure = {
                    request: "configure",
                    keyframe: true,
                    streams: [{
                        mid: videoMid,
                        keyframe: true
                    }]
                };
                videoRoomHandle.send({ message: configure });
            },

            /**
             * 暂停投屏按钮的点击事件处理
             */
             handlePause() {
                this.status = 'paused';
                this.projectionStatus = "textPause";
                // videoRoomHandle.muteAudio(audioMid);
                // videoRoomHandle.muteVideo(videoMid);
                let pause = {
                    request: "requestPause",
                    id: publisherId
                };
                videoRoomHandle.send({ message: pause });
            },

            /**
             * 继续投屏按钮的点击事件处理
             */
             handleResume() {
                this.status = 'running';
                this.projectionStatus = "textSharing";
                // videoRoomHandle.unmuteAudio(audioMid);
                // videoRoomHandle.unmuteVideo(videoMid);
                let start = {
                    request: "requestStart",
                    id: publisherId
                };
                videoRoomHandle.send({ message: start });
            },

            /**
             * 结束投屏按钮的点击事件处理
             */
            handleStop() {
                if (interval) {
                    clearInterval(interval);
                }
                this.status = "input";
                this.projectionStatus = "connectLabel";
                janus.destroy();
                window.location.reload();
            },

            /**
             * 处理收到的信令消息
             */
            handleMessage(msg, jsep) {
                console.log("msg = ", msg);
                let event = msg["videoroom"];
                if(event) {
                    if(event === "joined") {
                        publisherId = msg["id"];
                        this.roomName = msg["description"];
                        this.errorTipKey = ""
                        this.authorize();
                    } else if(event === "event") {
                        if(msg["error"]) {
                            if (msg["error_code"] == 426) {
                                this.errorTipKey = "codeInvalid";
                                this.projectionStatus = "connectLabel";
                                this.status = 'input';
                            } else if (msg["error_code"] == 432) {
                                this.jumpToError("maxPublishers");
                            }
                        } else if (msg["result"]) {
                            let result = msg["result"];
                            if (result["event"]) {
                                // 授权结果
                                if (this.status !== 'authorize' && this.status !== 'authorizing') {
                                    return;
                                }
                                if (result["event"] === 'agreed') {
                                    this.errorTipKey = "";
                                    if (result["display"]) {
                                        this.roomName = result["display"];
                                    }
                                    if (timeout) {
                                        clearTimeout(timeout);
                                    }
                                    this.startProjection();
                                } else if (result["event"] === 'refused') {
                                    if (timeout) {
                                        clearTimeout(timeout);
                                    }
                                    this.jumpToError("refused");
                                } else if (result["event"] === 'failed') {
                                    errorCount = errorCount + 1;
                                    if (errorCount > 4) {
                                        this.jumpToError("maxTime");
                                    } else {
                                        this.status = 'authorize';
                                        this.projectionStatus = "textInputVerificationCode";
                                        this.errorTipKey = "codeError";
                                    }
                                }
                            }
                        } else if (msg["leaving"] && msg["reason"] === "kicked") {
                            this.jumpToError("kicked");
                        } else if (msg["streams"]) {
                            for(let stream of msg["streams"]) {
                                if (stream["type"] === 'video') {
                                    videoMid = stream["mid"];
                                } else if (stream["type"] === 'audio') {
                                    audioMid = stream["mid"];
                                }
                            }

                        }
                    }
                }
                if(jsep) {
                    Janus.debug("Handling SDP as well...", jsep);
                    videoRoomHandle.handleRemoteJsep({ jsep: jsep });
                }
            },

            creatOffer() {
                videoRoomHandle.createOffer({
                    tracks: [
                        // { type: 'audio', capture: true, recv: false },
                        { type: 'screen', capture: true, recv: false },
                        { type: 'desktopAudio', capture: true, recv: false }
                    ],
                    success: (jsep) => {
                        Janus.debug("Got publisher SDP!", jsep);
                        let publish = { request: "configure", audio: true, video: true };
                        videoRoomHandle.send({ message: publish, jsep: jsep });
                        this.status = 'running';
                        this.projectionStatus = "textSharing";
                    },
                    error: (error) => {
                        // 用户在弹窗时取消了投屏
                        this.jumpToError("userCancel");
                    },
                });
            },

            jumpToError(msg) {
                this.errorTipKey = "";
                this.status = 'error';
                this.projectionStatus = msg;
                janus.destroy();
            },

            handleLocalTrack(track, on) {
                Janus.debug("handleLocalTrack track " + (on ? "added" : "removed") + ":", track);
                if (!on) {
                    // 点击浏览器工具条上的停止投屏时触发
                    this.handleStop();
                }
            },

            handleSettingHide() {
                this.showSetting = false;
                localStorage.setItem("displayName", this.displayName);
                localStorage.setItem("language", JSON.stringify(this.language));
            }
        }
    }
</script>

<style scoped>
    .logo_img {
        position: absolute;
        top: 23px;
        left: 26px;
        width: 115px;
        height: 24px;
    }

    .content {
        width: 100vw;
        height: 100vh;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
    }

    .content_img {
        margin-top: 22vh;
        width: 334px;
    }

    .content_tip {
        margin-top: 60px;
        font-size: 16px;
        color: #000;
        font-weight: 700;
        line-height: 23px;
    }

    .content_error {
        font-size: 14px;
        color: #E81616;
        margin-top: 7px;
    }

    .content_div {
        margin-top: 16px;
        position: relative;
        top: 0px;
        left: 0px;
        width: 213px;
        height: 35px;
    }

    .content_div_input {
        width: 100%;
        height: 100%;
        line-height: 35px;
        background-color: #F6F6F6;
        border-radius: 7px;
        font-size: 16px;
        color: #000;
        font-weight: 400;
        text-align: center;
        border-width: 0px;
        outline: none;
    }

    .content_div_img {
        position: absolute;
        top: 8px;
        left: 232px;
        width: 16px;
        height: 16px;
        animation: rotateAnimation 1s linear infinite;
    }

    @keyframes rotateAnimation {
        0%   { transform: rotate(0deg); } /* 初始状态 */
        100% { transform: rotate(360deg); } /* 结束状态 */
    }

    .content_footer {
        position: absolute;
        left: 0px;
        bottom: 0px;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 19px;
    }

    .content_footer_text {
        margin-top: 8px;
        font-size: 14px;
        color: #727272;
    }

    .setting_icon {
        position: absolute;
        right: 15px;
        bottom: 15px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 29px;
        height: 29px;
        z-index: 99;
        border-radius: 15px;
        cursor: pointer;
    }

    .setting_icon_img {
        width: 17px;
        height: 17px;
    }

    .setting_item {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        height: 50px;
        width: 270px;
        margin-left: 15px;
        margin-right: 15px;
        border-bottom: 1px solid #EFEFEF;

        &:last-child {
            border-bottom: 0px solid #EFEFEF;
        }
    }

    .setting_item_input {
        width: 120px;
        height: 21px;
        line-height: 21px;
        background-color: #F6F6F6;
        border-radius: 5px;
        font-size: 12px;
        color: #000;
        font-weight: 400;
        border-width: 0px;
        outline: none;
        padding-left: 6px;
        padding-right: 6px;
    }

    .setting_label {
        font-size: 16px;
        color: #000;
    }

    .setting_lang_item {
        width: 132px;
        padding-left: 7px;
        padding-right: 7px;
        border-radius: 5px;
        font-size: 12px;
        height: 21px;
        line-height: 21px;
        color: #000;
    }


</style>

<style>
.el-popover {
    padding: 0px;
    border-radius: 10px;
    min-width: 96px;
}
.el-input__inner {
    width: 132px;
    height: 21px;
    font-size: 12px;
    height: 21px;
    line-height: 21px;
    color: #000;
    border: 0px solid #000;
    padding-left: 6px;
    padding-right: 6px;
    background-color: #F6F6F6;
    border-radius: 5px;
}
.el-input__icon {
    color: #696969 !important;
    line-height: 21px;
}
.el-select-dropdown {
    border-radius: 5px;
    min-width: 96px !important;
    margin-bottom: 4px !important;
}
.el-select-dropdown__list {
    padding-top: 0px;
    padding-bottom: 0px;
}
.el-select-dropdown__item {
    font-size: 12px;
    height: 21px;
    line-height: 21px;
    color: #000;
    width: 132px;
    height: 21px;
    padding-left: 0px;
    padding-right: 0px;
    border-radius: 5px;
}
.el-popper .popper__arrow {
    display: none !important;
}
.el-scrollbar__bar.is-horizontal {
    display: none;
}
</style>